import { render, staticRenderFns } from "./consumerStatistics.vue?vue&type=template&id=cea667f0&scoped=true&"
import script from "./consumerStatistics.vue?vue&type=script&lang=js&"
export * from "./consumerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./consumerStatistics.vue?vue&type=style&index=0&id=cea667f0&scoped=true&lang=css&"
import style1 from "./consumerStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea667f0",
  null
  
)

export default component.exports